import URL from "../../config/url";
export default API => ({
    getMenuNew() {
        let url = URL.confUrl;
        return API({
            url: `/modular/admin/v1/configuration/${url}`
        });
    },
    getJiazhengExam() {
        return API({
            url:  '/gx-homemaking/v1/jz/findIndex'
        })
    },
})
